/**
 * What a person reads when a file gives no text. The reader's words
 * (`Refused`, in libs/crates/resume_reader) are for the resume service's own
 * callers. Where a person can do something about one, it has a line here.
 * Every other refusal, and anything not known here, is `UNREADABLE`, so no
 * technical word reaches the page.
 */
export const UNREADABLE = "This file could not be read. Paste the text instead.";

/** How a reader's refusal starts, and what is said for it. A number may follow the start. */
const PLAIN_WORDS: readonly (readonly [string, string])[] = [
    [
        "no text could be read from the file",
        "This file has no text we can read. Paste the text instead.",
    ],
    [
        "the file holds more text than a resume",
        "This file holds more text than a resume. Paste the part you want checked.",
    ],
    [
        "the PDF is encrypted",
        "This PDF is protected. Save it without protection and pick it again, or paste the text.",
    ],
];

/** The line for a reader's refusal. */
export function plainRefusal(refusal: string): string {
    return PLAIN_WORDS.find(([start]) => refusal.startsWith(start))?.[1] ?? UNREADABLE;
}
